var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 22,
    viewBox: "0 0 33 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.439453 21.1199L16.7195 7.91992L31.6795 21.1199",
    stroke: "#4F4F4F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7209 11.4399C11.0889 11.4399 3.81419 4.39988 0.880859 0.879883H31.6809C29.0409 4.39988 22.3529 11.4399 16.7209 11.4399Z",
    fill: "white",
    stroke: "#4F4F4F",
    strokeLinejoin: "bevel"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31.56,
    height: 21,
    rx: 1.5,
    stroke: "#4F4F4F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewEmail);
export default __webpack_public_path__ + "static/media/preview-email.af75610738847959a104e3c19eae015c.svg";
export { ForwardRef as ReactComponent };